// src/features/landing/presentation/components/BrokerageIntroSection.jsx
import React from "react";

export function BrokerageIntroSection() {
    const connections = [
        { left: "보험회사", center: "보험설계사", right: "고객" },
        { left: "공무주", center: "공인중개사", right: "매수인/임차인" },
        { left: "회사", center: "간병인재", right: "간병인" },
        { left: "보험회사", center: "GA매니저", right: "고객" },
        { left: "보험회사", center: "총무", right: "대리점/모집인" },
        { left: "사업주", center: "마케팅대행/실행사", right: "인플루언서" },
        { left: "광고판매업체", center: "구매대행인", right: "소비자" },
        { left: "공식 맛집", center: "공동구매플랫폼", right: "소비자" },
    ];

    return (
        <section className="brokerage-intro-section">
            <div className="brokerage-intro-container">
                {/* 상단 헤드라인 */}
                <div className="brokerage-header">
                    <h1 className="brokerage-headline">
                        세상의 모든 중개,{" "}
                        <span className="brokerage-brand">[ 라이징브로커즈 ]</span>가 함께
                        합니다.
                    </h1>
                </div>

                {/* 서브 헤드라인 */}
                <div className="brokerage-subheader">
                    <p className="brokerage-subtitle">
                        우리 사회 모든 거래의 본질은 <span className="emphasis-bracket">[ 중개 ]</span>{" "}
                        입니다.
                    </p>
                </div>

                {/* 중개 관계도 */}
                <div className="brokerage-connections">
                    {connections.map((conn, idx) => (
                        <div key={idx} className="connection-row">
                            <span className="connection-left">{conn.left}</span>
                            <span className="connection-line">—————</span>
                            <span className="connection-center">[ {conn.center} ]</span>
                            <span className="connection-line">—————</span>
                            <span className="connection-right">{conn.right}</span>
                        </div>
                    ))}
                </div>

                {/* 하단 메시지 */}
                <div className="brokerage-footer-message">
                    <p className="footer-text">
                        그 중 우리는 가장 먼저 "GA전문인력"에 집중하고자 합니다.
                    </p>
                </div>

                {/* 최하단 강조 */}
                <div className="brokerage-final-statement">
                    <div className="final-connection">
                        <span className="final-left">보험회사</span>
                        <span className="final-line">—————</span>
                        <span className="final-brand">[ 라이징브로커즈 ]</span>
                        <span className="final-line">—————</span>
                        <span className="final-right">GA매니저/총무/스태프</span>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .brokerage-intro-section {
                    width: 100%;
                    min-height: 100vh;
                    background: linear-gradient(
                        to bottom,
                        #f5f5f5 0%,
                        #e8e8e8 30%,
                        #4a5f7f 70%,
                        #1e3a5f 100%
                    );
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 60px 20px;
                }

                .brokerage-intro-container {
                    max-width: 1000px;
                    width: 100%;
                    text-align: center;
                }

                .brokerage-header {
                    margin-bottom: 50px;
                }

                .brokerage-headline {
                    font-size: 2.5rem;
                    font-weight: 700;
                    color: #2c3e50;
                    line-height: 1.4;
                    margin: 0;
                }

                .brokerage-brand {
                    color: #ff5722;
                    font-weight: 800;
                }

                .brokerage-subheader {
                    margin-bottom: 60px;
                }

                .brokerage-subtitle {
                    font-size: 1.5rem;
                    color: #34495e;
                    font-weight: 500;
                }

                .emphasis-bracket {
                    color: #2c3e50;
                    font-weight: 700;
                }

                .brokerage-connections {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    margin-bottom: 80px;
                    opacity: 0.85;
                }

                .connection-row {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 12px;
                    font-size: 1rem;
                    color: #5a6c7d;
                }

                .connection-left,
                .connection-right {
                    min-width: 140px;
                    text-align: center;
                    font-weight: 400;
                    color: #6c7a89;
                }

                .connection-line {
                    color: #b0b8c1;
                    letter-spacing: -2px;
                }

                .connection-center {
                    min-width: 180px;
                    color: #34495e;
                    font-weight: 600;
                }

                .brokerage-footer-message {
                    margin-bottom: 60px;
                }

                .footer-text {
                    font-size: 1.3rem;
                    color: #ecf0f1;
                    font-weight: 500;
                }

                .brokerage-final-statement {
                    padding: 40px 20px;
                }

                .final-connection {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 20px;
                    font-size: 1.8rem;
                    font-weight: 600;
                }

                .final-left,
                .final-right {
                    color: #ecf0f1;
                }

                .final-line {
                    color: rgba(236, 240, 241, 0.5);
                    letter-spacing: -2px;
                }

                .final-brand {
                    color: #ff5722;
                    font-weight: 800;
                    font-size: 2rem;
                }

                /* 반응형 */
                @media (max-width: 768px) {
                    .brokerage-headline {
                        font-size: 1.8rem;
                    }

                    .brokerage-subtitle {
                        font-size: 1.2rem;
                    }

                    .connection-row {
                        font-size: 0.75rem;
                        gap: 6px;
                    }

                    .connection-left,
                    .connection-right {
                        min-width: 80px;
                        font-size: 0.7rem;
                    }

                    .connection-center {
                        min-width: 100px;
                        font-size: 0.8rem;
                    }

                    .connection-line {
                        font-size: 0.7rem;
                    }

                    .footer-text {
                        font-size: 1rem;
                    }

                    .final-connection {
                        font-size: 1.1rem;
                        gap: 10px;
                        flex-wrap: wrap;
                    }

                    .final-brand {
                        font-size: 1.3rem;
                    }
                }

                @media (max-width: 480px) {
                    .brokerage-headline {
                        font-size: 1.4rem;
                    }

                    .brokerage-subtitle {
                        font-size: 1rem;
                    }

                    .connection-row {
                        font-size: 0.65rem;
                        gap: 4px;
                    }

                    .connection-left,
                    .connection-right {
                        min-width: 60px;
                        font-size: 0.6rem;
                    }

                    .connection-center {
                        min-width: 80px;
                        font-size: 0.7rem;
                    }

                    .final-connection {
                        font-size: 0.9rem;
                    }

                    .final-brand {
                        font-size: 1.1rem;
                    }
                }
            `}</style>
        </section>
    );
}
